var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0
import * as React from 'react';
import clsx from 'clsx';
import { NavLink } from 'react-router-dom';
import { Typography } from '../typography';
import styles from './Tabs.module.css';
export var Tab = function (_a) {
    var label = _a.label, active = _a.active, link = _a.link, tooltip = _a.tooltip, icon = _a.icon, className = _a.className, onTabClick = _a.onTabClick, children = _a.children;
    var Content = function () { return (_jsxs(_Fragment, { children: [icon && _jsx("div", __assign({ className: styles.icon }, { children: icon }), void 0), _jsx(Typography, __assign({ tooltip: tooltip, className: styles.tabText }, { children: label || children }), void 0)] }, void 0)); };
    if (link) {
        return (_jsx(NavLink, __assign({ to: link, className: function (_a) {
                var isActive = _a.isActive;
                return clsx(styles.pointer, styles.tab, className, (active || isActive) && styles.active);
            }, replace: true }, { children: _jsx(Content, {}, void 0) }), void 0));
    }
    return (_jsx("div", __assign({ className: clsx(styles.pointer, styles.tab, className, active && styles.active), onClick: onTabClick }, { children: _jsx(Content, {}, void 0) }), void 0));
};
export var Tabs = function (_a) {
    var tabs = _a.tabs, onTabClick = _a.onTabClick, activeTabKey = _a.activeTabKey, activeTab = _a.activeTab;
    var _b = React.useState(activeTabKey || 0), activeKey = _b[0], setActiveKey = _b[1];
    return (_jsx("div", __assign({ className: styles.tabs }, { children: tabs.map(function (tab, idx) { return (_jsx(Tab, __assign({ className: styles.tabsItem, active: tab.active || activeTabKey === idx || activeTab === tab.label || activeKey === idx, onTabClick: function () {
                setActiveKey(idx);
                onTabClick && onTabClick(idx);
                tab.onTabClick && tab.onTabClick(idx);
            } }, tab), tab.label)); }) }), void 0));
};
